<template >
    <div class="container-fluid" v-if="lesson">


       <div class="row">
      <div class="col-lg-4">
        <div class="card shadow mb-4">
          <div class="card-header">
            <h4>{{lesson.name}}</h4>
          </div>
          <div class="card-body">
            <h4 class="mb-1">Үнэ:
              <span class='badge badge-success' v-if="lesson.price==null || lesson.price==undefined || lesson.price==0">Free</span>
              <span class='badge badge-info' v-else>{{lesson.price}}</span>
            </h4>
            <p>{{lesson.description}}</p>
            <div class="btn btn-info btn-sm">
              <router-link :to="{ name: 'LessonEdit', params: { lessonId: lesson.id}}" class="text-white">Хичээлийн мэдээлэл засах</router-link>
            </div>
            <div class="btn btn-default  btn-sm mx-1 my-2">
              <router-link :to="{ name: 'ImageAdd', params: { objectPath: 'lessons/'+lesson.id}}">Хичээлийн зураг оруулах</router-link>
            </div>
            <br/>

            <br/>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <button class="btn btn-outline-secondary btn-sm" type="button" v-for="type in lesson.types">
                  {{type}}

                </button>

              </div>
            </div>
            
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card shadow mb-4">
          <div class="card-header">
            <h4>Мэдээлэл</h4>
          </div>
          <div class="card-body">
            <p style="margin-bottom: 0rem;">Багш:<span style="font-weight:bold">{{lesson.profession}}</span></p>
            <p style="margin-bottom: 0rem;">Xичээлийн код: <span style="font-weight:bold">{{lesson.lectureCode}}, {{lesson.id}}</span></p>
            <p style="margin-bottom: 0rem;" v-if="lesson.semester">Улирал: <span style="font-weight:bold">{{lesson.semester.id}}</span></p>
            <p style="margin-bottom: 0rem;" v-if="lesson.credit">Кредит: <span style="font-weight:bold">{{lesson.credit}}</span></p>
            <p style="margin-bottom: 0rem;" v-if="lesson.school">Сургууль: <span style="font-weight:bold">{{lesson.school.id}}</span></p>
            <p style="margin-bottom: 0rem;" v-if="lesson.department">Xөтөлбөрийн баг: <span style="font-weight:bold">{{lesson.department.id}}</span></p>
            <p style="margin-bottom: 0rem;" v-if="lesson.program">Хөтөлбөр: <span style="font-weight:bold">{{lesson.program.id}}</span></p>
          </div>
        </div>
      </div>


    </div>

    <hr class="mb-5"/>


      <div class="card shadow mb-4">
        <div class="card-header py-3">
          <div class="row">
            <h4>Хичээл худалдан авах хүсэлтүүд</h4>


          </div>
        </div>
        <div class="card-body" >
          <div class="table-responsive" v-if="users!=null && users.length>0">
                <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                    <tr>
                        <th>№</th>
                        <th>КОД</th>
                        <th>ХЭРЭГЛЭГЧ</th>
                        <th>Төлөв</th>
                        <th>Үйлдэл</th>
                    </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(payment, index) in users" v-bind:key="payment.id">
                            <td>{{index+1}}</td>
                            <td>{{payment.paidcode}}</td>
                            <td>
                                <span v-if="payment.user!=null">{{payment.user.id}}</span>
                                <span v-else>USER</span>
                                <br/>
                                <div v-if="payment.userData!=null">
                                    <h5>{{payment.userData.name}}</h5>
                                    
                                    <span>{{payment.userData.email}}</span>
                                </div>
                            </td>
                 
                            <td>
                                <span v-if="payment.paid==null || payment.paid==undefined || payment.paid==false" class="badge badge-danger">Not paid</span>
                                <span v-else class="badge badge-success">Paid</span>
                            </td>
                            <td>
                                <span v-if='payment.loading!=true'>
                                  <button v-if="payment.paid==null || payment.paid==undefined || payment.paid==false" @click="submit(payment)" class="btn btn-warning btn-sm ml-2" >Эрх нээх</button>
                                  <button v-else @click="block(payment)" class="btn btn-danger btn-sm ml-2" >Эрх хаах</button>
                                
                                </span>
                                <span v-else>
                                    <button type="button" class="btn btn-google btn-block" disabled>
                                    <span class="spinner-border spinner-border-sm"></span>
                                    Loading..
                                    </button>
                                </span>
                            </td>
                        </tr>
                    
                    </tbody>
                </table>
                    <!-- <div v-if="!searched">
                        <button v-if="loading==false" @click="getStudentsData()" class="btn btn-success btn-block">Дараагийнх</button>
                        <button v-else type="button" class="btn btn-success btn-block" disabled>
                            <span class="spinner-border spinner-border-sm"></span>
                            Loading..
                        </button>
                    </div> -->
                </div>
                <div v-else class="alert alert-info text-center">Одоогоор төлбөрийн мэдээлэл ороогүй байна.</div>

        </div>
      </div>
      <hr class="mb-5"/>

    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import firebase from 'firebase'

export default {
    name: "LessonPayment",

    data() {
        return {
            lesson: null,
            users:[]
        };
    },
    methods: {
        
      _getQA(){

        fb.db.collection("lessons").doc(this.lessonId).onSnapshot(doc=> {
          this.users=[];
            let lesson=doc.data();
            lesson.id=doc.id;
            this.lesson=lesson;
      
            doc.ref.collection("paymentusers").orderBy("createdAt").get().then((docs)=>{
              if(docs!=null && !docs.empty){
                for(const dd of docs.docs){
                  if(dd.exists){
                    let object=dd.data();
                    object.ref=dd.ref;
                    object.userData=null;
                    object.loading=false;
                    if(object.user!=null){
                      object.user.get().then((userDoc)=>{
                        let ud=userDoc.data();
                        ud.id=userDoc.id;
                        object.userData=ud;
                      });
                    }
                    this.users.push(object);
                  }
                }
              }
            });
          
        });


      },
      submit(payment){
          if(payment.ref!=null){
            payment.loading=true;
            var batch = fb.db.batch();
            batch.update(
              payment.ref,
              {
                'paid': true,
                'paidAt':new Date(),
                'status':"buyed"
              }
            );
            batch.update(
              fb.db.collection("users").doc(payment.user.id+"/categoryList/"+this.lesson.category.id+"/savedlessons/"+this.lesson.id),
              {
                'paid': true,
                'paidAt':new Date(),
                'status':"buyed"
              }
            );
            batch.update(
              fb.db.collection("users").doc(payment.user.id+"/categoryList/"+this.lesson.category.id),
              {
                "status":"buyed"
              }
            );
            batch.commit().then( () =>{
              payment.paid=true;
              payment.status="buyed";
              payment.loading=false;
            });
          }
          
      },
      block(payment){
          if(payment.ref!=null){
            payment.loading=true;
            var batch = fb.db.batch();
            batch.update(
              payment.ref,
              {
                'paid': false,
                'rejectedAt':new Date(),
                'status':"pending"
              }
            );
            batch.update(
              fb.db.collection("users").doc(payment.user.id+"/categoryList/"+this.lesson.category.id+"/savedlessons/"+this.lesson.id),
              {
                'paid': false,
                'rejectedAt':new Date(),
                'status':"pending"
              }
            );
            batch.update(
              fb.db.collection("users").doc(payment.user.id+"/categoryList/"+this.lesson.category.id),
              {
                "status":"pending"
              }
            );
            batch.commit().then( () =>{
              payment.paid=false;
              payment.status="pending";
              payment.loading=false;
            });
          }
          
      },

      setPropContent(value,topic, item, propertyName){
        if(this.lesson!=null && topic!=null && item!=null && propertyName!=null)
          this.setProperty(propertyName, fb.db.doc("lessons/"+this.lesson.id+"/topics/"+topic.id+"/details/"+item.id), value);
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },

      setPublished(value, lesson){
        this.setProperty("published", fb.db.doc("lessons/"+lesson.id), value);
        if(value==true){
          if(lesson.school!=null && lesson.school!=undefined)
            lesson.school.update({"publishedLesson": fb.firestore.FieldValue.increment(1)});
          if(lesson.department!=null && lesson.department!=undefined)
            lesson.department.update({"publishedLesson": fb.firestore.FieldValue.increment(1)});
          if(lesson.program!=null && lesson.program!=undefined)
            lesson.program.update({"publishedLesson": fb.firestore.FieldValue.increment(1)});

          var publish = firebase.functions().httpsCallable('publishLesson');
          publish(
            { lessonId: lesson.id}
          );
        }
        else{
          if(lesson.school!=null && lesson.school!=undefined)
            lesson.school.update({"publishedLesson": fb.firestore.FieldValue.increment(-1)});
          if(lesson.department!=null && lesson.department!=undefined)
            lesson.department.update({"publishedLesson": fb.firestore.FieldValue.increment(-1)});
          if(lesson.program!=null && lesson.program!=undefined)
            lesson.program.update({"publishedLesson": fb.firestore.FieldValue.increment(-1)});
          var unpublish = firebase.functions().httpsCallable('unPublishLesson');
          unpublish(
            { lessonId: lesson.id}
          );
        }
      },
    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        lessonId: { 
            required: true,
        },
        topicId:{
          required:true
        },
        contentId:{
          required:true
        } 
    },
    created() {
        var _this=this;
        if(this.lessonId!=null && this.lessonId!='')
          this._getQA();
            
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm');
      },
    }
  
};
</script>

